/**
 * Utility functions for mapping risk levels and timeframes to colors
 * based on the current theme mode (light/dark)
 */

export type RiskLevel = "Low" | "Medium" | "High";
export type TimeframeLabel = "Short" | "Medium" | "Long";
export type ThemeMode = "light" | "dark";

interface ColorMapping {
  light: string;
  dark: string;
}

const RISK_LEVEL_COLORS: Record<RiskLevel, ColorMapping> = {
  Low: {
    light: "#09A856",
    dark: "#00D355",
  },
  Medium: {
    light: "#565EFA",
    dark: "#FFFFFF",
  },
  High: {
    light: "#FC9429",
    dark: "#FC9429",
  },
};

const TIMEFRAME_COLORS: Record<TimeframeLabel, ColorMapping> = {
  Short: {
    light: "#09A856",
    dark: "#00D355",
  },
  Medium: {
    light: "#565EFA",
    dark: "#FFFFFF",
  },
  Long: {
    light: "#FC9429",
    dark: "#FC9429",
  },
};

/**
 * Gets the appropriate color for a risk level based on the current theme mode
 */
export const getRiskLevelColor = (riskLevel: string, themeMode: ThemeMode): string => {
  const level = riskLevel as RiskLevel;
  if (!RISK_LEVEL_COLORS[level]) {
    // Fallback to default green if invalid risk level
    return themeMode === "light" ? "#09A856" : "#00D355";
  }
  return RISK_LEVEL_COLORS[level][themeMode];
};

/**
 * Gets the appropriate color for a timeframe label based on the current theme mode
 */
export const getTimeframeLabelColor = (timeframeLabel: string, themeMode: ThemeMode): string => {
  const label = timeframeLabel as TimeframeLabel;
  if (!TIMEFRAME_COLORS[label]) {
    // Fallback to default green if invalid timeframe label
    return themeMode === "light" ? "#09A856" : "#00D355";
  }
  return TIMEFRAME_COLORS[label][themeMode];
};
